export default {
  table: "table",
  rowGroup: "rowgroup",
  row: "row",
  columnHeader: "columnheader",
  cell: "cell",
};
